import React, { Component } from 'react';
import { Error404, Error500 } from 'features/shared/errors/ErrorPages';

export const Error404Page = () => {
  return <Error404 />;
};

export const Error500Page = () => {
  return <Error500 />;
};
